import { render, staticRenderFns } from "./SendFeriaRequest.vue?vue&type=template&id=338ebe22"
import script from "./SendFeriaRequest.vue?vue&type=script&lang=ts"
export * from "./SendFeriaRequest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports